import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CONSENT_KEY = "cookie-consent";

const GA_ID = process.env.REACT_APP_GA_ID;

// Oficiální GA opt-out přepínač: před souhlasem a po jeho odvolání je měření vypnuté.
const setGaDisabled = (disabled) => {
  if (GA_ID) window[`ga-disable-${GA_ID}`] = disabled;
};

const clearGaCookies = () => {
  const parts = window.location.hostname.split(".");
  const domains = [""];
  for (let i = 0; i < parts.length - 1; i++) {
    domains.push(`.${parts.slice(i).join(".")}`);
  }
  document.cookie.split(";").forEach((c) => {
    const name = c.trim().split("=")[0];
    if (name.startsWith("_ga")) {
      domains.forEach((d) => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${d ? `; domain=${d}` : ""}`;
      });
    }
  });
};

// Měřicí/reklamní nástroje se načtou až po souhlasu a pouze pokud jsou nakonfigurované.
const loadAnalytics = () => {
  if (GA_ID && !document.getElementById("ga-script")) {
    const s = document.createElement("script");
    s.id = "ga-script";
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
    const inline = document.createElement("script");
    inline.textContent = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments)}gtag('js',new Date());gtag('config','${GA_ID}');`;
    document.head.appendChild(inline);
  }
};

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) {
      setGaDisabled(true);
      setVisible(true);
    } else if (stored === "all") {
      setGaDisabled(false);
      loadAnalytics();
    } else {
      setGaDisabled(true);
    }
    const open = () => setVisible(true);
    window.addEventListener("open-cookie-settings", open);
    return () => window.removeEventListener("open-cookie-settings", open);
  }, []);

  const choose = (value) => {
    localStorage.setItem(CONSENT_KEY, value);
    setVisible(false);
    if (value === "all") {
      setGaDisabled(false);
      loadAnalytics();
    } else {
      setGaDisabled(true);
      clearGaCookies();
    }
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Nastavení cookies"
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 sm:right-auto sm:left-6 sm:max-w-xl z-50 bg-white border border-[#E5E5E5] shadow-[0_8px_40px_rgba(0,0,0,0.08)] p-6 md:p-8"
    >
      <h2 className="font-display text-xl md:text-2xl text-[#252525]">
        Můžu použít cookies pro měření a reklamu?
      </h2>
      <p className="text-sm text-[#4A4A4A] leading-relaxed mt-3">
        Díky nim poznám, co lidem na webu pomohlo a jestli se reklama vyplatí.
        Měření spustím jen s vaším souhlasem.{" "}
        <Link
          to="/ochrana-osobnich-udaju"
          data-testid="cookie-more-link"
          className="underline underline-offset-2 text-[#252525] hover:text-[#B69A58] transition-colors duration-300"
        >
          Více informací
        </Link>
      </p>
      <div className="flex flex-col sm:flex-row gap-3 mt-6">
        <button
          type="button"
          data-testid="cookie-necessary-button"
          onClick={() => choose("necessary")}
          className="flex-1 border border-[#B69A58] bg-white text-[#252525] hover:bg-[#B69A58] hover:text-white transition-colors duration-300 px-6 py-3 text-xs uppercase tracking-widest font-medium"
        >
          Jen nezbytné
        </button>
        <button
          type="button"
          data-testid="cookie-accept-button"
          onClick={() => choose("all")}
          className="flex-1 border border-[#B69A58] bg-white text-[#252525] hover:bg-[#B69A58] hover:text-white transition-colors duration-300 px-6 py-3 text-xs uppercase tracking-widest font-medium"
        >
          Souhlasím
        </button>
      </div>
    </div>
  );
};
